// src/pages/HistorialEconomico.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import Topbar from '../components/Topbar';
import Breadcrumb from '../components/Breadcrumb';
import '../styles/HistorialEconomico.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';

export default function HistorialEconomico() {
  const [resultados, setResultados] = useState([]);
  const { expediente } = useParams();
  const history = useHistory();
  const [actuaciones, setActuaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [seleccionados, setSeleccionados] = useState([]);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [tratamientosDisponibles, setTratamientosDisponibles] = useState([]);
  
  const calcularTotalFila = (cantidad, importe) => cantidad * importe;

  const totalGlobal = resultados.reduce((acc, r) => {
    const cantidad = (1);
    const importe = Number(r.importe || 0);
    return acc + calcularTotalFila(cantidad, importe);
  }, 0);

  useEffect(() => {
    async function fetchHistorial() {
      try {
        const { data } = await axios.get(
          `/api/actuaciones/paciente/${expediente}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        );
        setResultados(data);
        setActuaciones(data);
      } catch (err) {
        console.error('Error al cargar historial', err.response || err);
      } finally {
        setLoading(false);
      }
    }

    fetchHistorial();
  }, [expediente]);


  useEffect(() => {
  async function fetchTratamientos() {
    try {
      const { data } = await axios.get('/api/tratamientos', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      const opciones = data.map(t => ({
        value: t.nTratamiento,
        label: t.denominacion
      }));
      setTratamientosDisponibles(opciones);
    } catch (err) {
      console.error('Error al cargar tratamientos', err.response || err);
    }
  }

    fetchTratamientos();
  }, []);

  if (loading) return <p>Cargando historial económico...</p>;
  return (
    <>
      <ToastContainer />
      <Topbar />
      <div className="historial-economico-page">
      <Breadcrumb />
        <h2>Historial Económico del Paciente {expediente}</h2>
        <table className="historial-table">
            <thead>
              <tr>
                  <th>ID</th>
                  <th>Día</th>
                  <th>Tratamiento</th>
                  <th>Pieza</th>
                  <th>Cuadrante</th>
                  <th>Arcada</th>
                  <th>Realizado</th>
                  <th>Facturado</th>
                  <th>Pendiente</th>
                  <th>Importe</th>
              </tr>
            </thead>
            <tbody>
              {actuaciones.map(act => {
                const enEdicion = modoEdicion && seleccionados.includes(act.id);
                return (
                  <tr key={act.id}>                
                    <td>{act.id}</td>
                    <td>{act.dia}</td>
                    <td>{tratamientosDisponibles.find(t => t.value === act.tratamiento)?.label || act.tratamiento}</td>
                    <td>{act.n_pieza}</td>
                    <td>{act.cuadrante}</td>
                    <td>{act.arcada}</td>
                    <td>
                      <span className={act.realizado ? 'color-si' : 'color-no'}>
                          {act.realizado ? 'Sí' : 'No'}
                      </span>
                    </td>
                    <td>
                      <span className={act.n_factura ? 'color-si' : 'color-no'}>
                        {act.n_factura ? 'Sí' : 'No'}
                      </span>
                    </td>
                    <td>{act.pendiente_pago} </td>  
                    <td>{(1 * act.importe - act.pendiente_pago).toFixed(2)} €</td>               
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
                <tr>
                    <td colSpan={9} style={{ textAlign: "right", fontWeight: "bold" }}>Total:</td>
                     <td style={{ fontWeight: "bold" }}>{totalGlobal.toFixed(2)} €</td>

                </tr>
            </tfoot>
        </table>      
        <div className="acciones-inferiores">
          <button
            className="volver-btn"
            onClick={() => history.push(`/pacientes/${expediente}`)}
          >
            Volver al paciente
          </button>
        </div>
      </div>
    </>
  );
}
